// @flow
import createAction from 'Store/utils/createAction';
import {
  FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE,
  FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON,
  FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE,
} from './constants';

function toggleProductComparisonSelectionMode() {
  return (dispatch: ReduxDispatch) => {
    return dispatch(createAction(FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE));
  };
}

function setProductComparisonSelectionMode(enable: boolean) {
  return (dispatch: ReduxDispatch) => {
    dispatch(createAction(FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE, { enable }));
  };
}

function toggleProductSelected(productId: string) {
  return (dispatch: ReduxDispatch) => {
    return dispatch(createAction(FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON, { productId }));
  };
}

export {
  toggleProductComparisonSelectionMode,
  toggleProductSelected,
  setProductComparisonSelectionMode,
};
